import TimeOutService from '@SharedServices/time.out.service';
import Vue from 'vue';

const idleAutoLogOut = new Vue({
    el: '#auto-logout-confirmation',
    data: {
        isSavingData: false,
        timeOutService: new TimeOutService()
    },
    mounted: function () {
        if (this.$refs.idleIsOn.value == 'True') {
            this.timeOutService.Start();
            $(document.body).bind('keydown', this.ResetTimer);

            //this is a scroll issue. If you have compose message open and typing stuff.
            //let the idle timeout warning open
            //hit continue
            //the compose message comes back so you can continue on 
            //however, the scroll is busted and you can't scroll
            $('#auto-logout-confirmation').on('hidden.bs.modal', e => {

                //if there are any open modals after the logout confirmation is closed...then add a modal-open class to the document body
                if ($('.modal:visible').length > 0) {
                    $('body').addClass('modal-open');
                }
            });
        }
    },
    watch: {

        'timeOutService.result': {
            handler: function (newValue) {

                if (newValue.status == 'UserIsActive') {
                    $('#auto-logout-confirmation').modal('hide');
                }
                else if (newValue.status == 'UserIsIdle') {
                    //always hide other dialogs that could be visible in portal (exclude the actual logout dialog)
                    // $('.modal:visible').not('#auto-logout-confirmation').modal('hide');

                    $('.modal:visible').not('#auto-logout-confirmation').children().addClass("timeout");
                    //go show the auto logout dialog
                    $('#auto-logout-confirmation').modal('show');
                }
                else if (newValue.status == 'LogUserOut') {
                    this.LogOut(this.$refs.logOutUrl.value);
                }
            },
            deep: true
        }
    },
    computed: {
        secondsLeftInAbsolute: function () {
            return Math.abs(this.timeOutService.result.secondsUntilLogOut);
        },

        configuredInactiveTime: function () {
            return Math.abs(this.timeOutService.config.showIdleWarningInSeconds / 60);
        },

        showRemainingTimeInDialog: function () {
            return this.timeOutService && this.timeOutService.status != 'UserIsActive' && this.timeOutService.result.secondsUntilLogOut > 0;
        }
    },
    methods: {
        iAmActive: function () {

            //closing it so they can't hit the submit button multiple times. So we just hide the dialog and fire and forget the call. (Instead of disabling the button)
            $('#auto-logout-confirmation').modal('hide');
           
            $('.modal:visible').not('#auto-logout-confirmation').children().removeClass("timeout");

            this.timeOutService.ResetTimer();
        },
        LogOut: function (logOutUrl) {
            window.location.href = logOutUrl;
        },
        ResetTimer: function () {
            if (this.timeOutService.result.status == 'UserIsActive') {
                this.timeOutService.ResetTimer(false);
            }
        }
    }
});

export const IdleTimeOut = idleAutoLogOut;